export default "__VITE_ASSET__qz29XvaJ__"